import { render, staticRenderFns } from "./catalog-list-car.vue?vue&type=template&id=d4eb9de8"
import script from "./catalog-list-car.vue?vue&type=script&lang=js"
export * from "./catalog-list-car.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeadingH2: require('/var/www/components/heading/heading-h2.vue').default,ButtonTypical: require('/var/www/components/button/button-typical.vue').default})
